import React, {Component} from 'react';
import UniversalLink from 'components/UniversalLink'

import {Form} from 'form';
import ModalPaymentOverlay from 'components/modals/ModalPaymentOverlay';

import 'sass/payment/PaymentForm.scss';
import {formatAmount} from '../../utils/payment';

import {t, dt} from 'l10n';

const PENDING = 'pending',
    PROCESSING = 'processing',
    ERROR = 'error',
    AUTH = 'auth',
    DONE = 'done';

class PaymentForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            state: PENDING,
            backendError: null,
            paymentResult: null
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
        this.onSubmitError = this.onSubmitError.bind(this);
        this.onPaymentOverlayClose = this.onPaymentOverlayClose.bind(this);

    }

    onSubmit(formData, setErrors) {
        let {backendFn, additionalData, returnPath} = this.props;

        formData = {...formData, ...additionalData, returnPath};

        this.setState({state: PROCESSING});

        backendFn(formData)
            .then(this.onSubmitSuccess)
            .catch(this.onSubmitError);
    }

    onSubmitSuccess({result, ...rest}) {
        this.setState({
            state: AUTH,
            paymentResult: result
        });

        if (typeof this.props.onSuccess === 'function') {
            this.props.onSuccess(rest);
        }
    }

    onSubmitError(error) {
        this.setState({
            state: ERROR,
            backendError: error.messages || error.message
        });
    }

    cvcToPassword(event)
    {
        event.target.type = 'password';
    }

    onPaymentOverlayClose(event)
    {
        this.setState({
            state: PENDING
        });
    }

    render() {
        let {currentUser, returnPath} = this.props;
        let {state, backendError, paymentResult} = this.state;

        let paymentOverlayBody;

        switch (state) {
            case PROCESSING:
                paymentOverlayBody = (
                    <div>
                        <p className="loading">{dt('xxl', 'Please wait, your payment is being processed...')}</p>
                    </div>
                ); break;
            case ERROR:
                paymentOverlayBody = (
                    <div>
                        <p>{backendError}</p>
                        <a className="btn-submit" onClick={() => this.setState({state: PENDING})}>OK</a>
                    </div>
                ); break;
            case AUTH:
                paymentOverlayBody = (
                    <div>
                        <div className="close" onClick={this.onPaymentOverlayClose}/>
                        <iframe src={"/pb/3ds/?sid=" + paymentResult.SessionId} width="100%" height="600" border="0"></iframe>
                    </div>
                ); break;
            case DONE:
                paymentOverlayBody = (
                    <div>
                        <p><strong>{dt('xxl', 'Your payment has been done successfully.')}</strong></p>

                        {dt('xxl', 'Details of your transaction:')}

                        <div className="transaction-details">
                            <strong>{dt('xxl', 'Amount:')}</strong>&nbsp;{formatAmount(paymentResult.amount, false)}<br/>
                            <strong>{dt('xxl', 'Credit card number:')}</strong>&nbsp;{paymentResult.card_number}<br/>
                            <strong>{dt('xxl', 'Reference of your transaction:')}</strong>&nbsp;{paymentResult.reference}<br/>
                            <strong>{dt('xxl', 'A message has been sent to the following email address:')}</strong> {paymentResult.email}
                        </div>

                        {returnPath ?
                            <UniversalLink className="btn-submit" to={returnPath}>{dt('xxl', 'Continue')}</UniversalLink>:
                            <a className="btn-submit" onClick={() => this.setState({state: PENDING})}>{dt('xxl', 'Continue')}</a>
                        }

                    </div>
                ); break;
        }


        return (
            <div>
                <ModalPaymentOverlay show={!!paymentOverlayBody}>
                    {paymentOverlayBody}
                </ModalPaymentOverlay>

                <Form className="payment-form" onSubmit={this.onSubmit}>

                    <div className="help-text-block">
                        <p className="help-text secure-icon">{dt('xxl', 'Secure server, payment page is encrypted with 256-bit SSL.')}</p>
                    </div>

                    <div className="cards-block">
                        <div className="card1"></div>
                        <div className="card2"></div>
                        <div className="card3"></div>
                    </div>

                    <div className="FormInput">
                        <p className="label">{dt('xxl', 'Credit card number:')}</p>
                        <div className="number-card">
                            <input
                                type="text"
                                name="cn"
                                maxLength="16"
                                required
                                autoComplete="cc-number"
                            />
                        </div>
                    </div>

                    <div className="FormInput">
                        <p className="label">{dt('xxl', 'Expiration date:')}</p>
                        <div className="number-card-block expiration">
                            <div>
                                <ExpirationMonthSelect name="exp_month" required autoComplete="cc-exp-month"/>
                            </div>

                            <div>
                                <ExpirationYearSelect name="exp_year" required autoComplete="cc-exp-year"/>
                            </div>
                        </div>
                    </div>

                    <div className="FormInput">
                        <p className="label">{dt('xxl', 'Security code:')}</p>
                        <div className="security-block">
                            <div>
                                <input type="text" name="cvv" required autoComplete="cc-csc" onFocus={this.cvcToPassword} />
                            </div>
                            <div>
                                <p>{dt('xxl', 'This code consists of the last 3 digits at the back side of most credit cards.')}</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p className="label">{dt('xxl', 'Your email address:')}</p>
                        <input type="email" name="email" defaultValue={currentUser.email} required autoComplete="email"/>
                    </div>

                    <div className="text-info">
                        <p>{dt('xxl', 'Your payment confirmation will be sent to this email address. Be sure to specify a valid address to receive this message.')}</p>
                        <p>{dt('xxl', 'Check your SPAM folder if you do not receive this message in your inbox.')}</p>
                    </div>

                    <div className="button-block">
                        <div>
                            <button type="submit" className="btn-submit">{dt('xxl', 'Confirm your payment')}</button>
                        </div>
                        <div>
                            {<UniversalLink to={returnPath ? returnPath : {pathname: '/'}} className="btn-cancel">{t('Cancel')}</UniversalLink>}
                        </div>
                    </div>
                </Form>
            </div>
        )
    }
}

function ExpirationMonthSelect(props) {
    const months = [
        <option value="01" key="01">{dt('xxl', '01 - January')}</option>,
        <option value="02" key="02">{dt('xxl', '02 - February')}</option>,
        <option value="03" key="03">{dt('xxl', '03 - March')}</option>,
        <option value="04" key="04">{dt('xxl', '04 - April')}</option>,
        <option value="05" key="05">{dt('xxl', '05 - May')}</option>,
        <option value="06" key="06">{dt('xxl', '06 - June')}</option>,
        <option value="07" key="07">{dt('xxl', '07 - July')}</option>,
        <option value="08" key="08">{dt('xxl', '08 - August')}</option>,
        <option value="09" key="09">{dt('xxl', '09 - September')}</option>,
        <option value="10" key="10">{dt('xxl', '10 - October')}</option>,
        <option value="11" key="11">{dt('xxl', '11 - November')}</option>,
        <option value="12" key="12">{dt('xxl', '12 - December')}</option>,
    ];

    return (
        <select {...props}>
            {months}
        </select>
    )
}

function ExpirationYearSelect(props) {
    let currentYear = new Date().getFullYear();

    let years = [];
    for (let i = 0; i < 11; i++) {
        years.push(<option value={currentYear+i} key={i}>{currentYear+i}</option>)
    }

    return (
        <select {...props}>{years}</select>
    )
}

export default PaymentForm;


// WEBPACK FOOTER //
// ./src/components/payment/PaymentForm.js